import { PageController } from '@client/components/_core/layout/PageController';
import { NotFound } from '@client/components/NotFound';
import { useFeatureFlag } from '@client/hooks/useFeatureFlag';
import {
    ENABLE_CLAIM_BANK_FILES_FLAG,
    ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG,
    ENABLE_CLAIMS_AUTHORITY_FLAG,
} from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { Landmark } from 'lucide-react';
import { BankAccountPage } from './BankAccountPage';

export const Route = createFileRoute('/console/$orgId/configuration/financials/bank-account')({
    staticData: {
        metadata: {
            title: 'Bank account',
        },
        ui: {
            icon: Landmark,
            title: 'Bank account',
            subtitle: 'The account your bank files pay claims from',
            menuDescription: 'The account your bank files pay claims from',
        },
        // CUR-2808 (BF-A2): org admins add and change it; the Accounts role reads it; nobody else has it.
        // A route takes one flag: the page checks the payment approval flags too, and the server answers
        // NOT_FOUND without all three.
        modules: ['claim'],
        permissions: ['org:admin', 'org_bank_account:read'],
        featureFlag: ENABLE_CLAIM_BANK_FILES_FLAG,
    },
    component: RouteComponent,
});

function RouteComponent() {
    const claimsAuthority = useFeatureFlag(ENABLE_CLAIMS_AUTHORITY_FLAG, false);
    const paymentApproval = useFeatureFlag(ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG, false);
    return (
        <PageController route={Route}>
            {claimsAuthority && paymentApproval ? <BankAccountPage /> : <NotFound />}
        </PageController>
    );
}
